import {Component, EventEmitter, inject, OnInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";

import {ToastrService} from "ngx-toastr";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

import {AdCommentApiService} from "@numizmat/services/core";
import {AdCommentResponse, InsertAdCommentRequest, UpdateAdCommentRequest} from "@numizmat/services-models/core";

@Component({
  selector: 'nz-ad-comment-modal',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './ad-comment-modal.component.html',
  styleUrl: './ad-comment-modal.component.scss'
})
export class AdCommentModalComponent implements OnInit {
  private activeModal: NgbActiveModal = inject(NgbActiveModal);
  private toastrService: ToastrService = inject(ToastrService);
  private adCommentApiService: AdCommentApiService = inject(AdCommentApiService);

  protected emittedData: EventEmitter<any> = new EventEmitter();

  protected adId!: string;
  protected adComment?: AdCommentResponse;
  protected loading: boolean = false;
  protected mode!: 'create' | 'update';
  protected form: FormGroup = this.initializeForm();

  public ngOnInit(): void {
    if (this.mode === 'update') {
      this.content?.setValue(this.adComment?.content);
    }
  }

  protected onSubmit() {
    this.content?.setValue(this.content?.value?.trim());
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      return;
    }
    this.loading = true;
    if (this.mode === 'create') {
      const request: InsertAdCommentRequest = {
        adId: this.adId,
        content: this.content?.value
      };
      this.adCommentApiService.insertAdComment(request).subscribe({
        next: response => {
          this.loading = false;
          this.emittedData.emit(response);
          this.toastrService.success("Успешно добавихте коментар.");
          this.closeModal();
        }
      });
    } else {
      const request: UpdateAdCommentRequest = {
        content: this.content?.value
      };
      this.adCommentApiService.updateAdComment(this.adComment!.adCommentId, request).subscribe({
        next: response => {
          this.loading = false;
          this.emittedData.emit(this.content?.value);
          this.toastrService.success("Успешно редактирахте коментар.");
          this.closeModal();
        }
      });
    }
  }

  protected closeModal(): void {
    this.activeModal.dismiss();
  }

  private initializeForm() {
    return new FormGroup({
      content: new FormControl(null, [Validators.required, Validators.maxLength(2000)])
    });
  }

  get content() {
    return this.form.get('content');
  }
}
